import api from './api';

export default {
    async getParameters(token, id) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get(`/service/parameters/${id}`, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar tripulantes:', error);
                throw error;
        }
    },
}

